import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
} from '@apollo/client';
import { ErrorLink } from '@apollo/client/link/error';
import * as R from 'ramda';
import { map } from 'rxjs';

import accountUtilities from '@atom/utilities/accountUtilities';
import { GRAPHQL_ENDPOINT } from '@atom/utilities/endpoints';
import { interceptApolloError } from '@atom/utilities/interceptors';
import {
  ATOM_CLIENT_TIMEZONE_HEADER,
  ATOM_DEVICE_HEADER,
  ATOM_USER_HEADER,
  DEFAULT_HEADERS,
} from '@atom/utilities/requestUtilities';

const headersLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers }) => {
    const email = accountUtilities.getLoggedInEmail();

    return {
      headers: {
        ...headers,
        [ATOM_USER_HEADER]: email || '',
        [ATOM_DEVICE_HEADER]: DEFAULT_HEADERS[ATOM_DEVICE_HEADER],
        [ATOM_CLIENT_TIMEZONE_HEADER]:
          DEFAULT_HEADERS[ATOM_CLIENT_TIMEZONE_HEADER],
      },
    };
  });
  return forward(operation).pipe(map(result => result));
});

const errorLink = new ErrorLink(error => {
  interceptApolloError({ ...error });
});

const httpLink = new HttpLink({
  uri: GRAPHQL_ENDPOINT,
});

const client = new ApolloClient({
  cache: new InMemoryCache({
    resultCaching: true,
    typePolicies: {
      ExportProjection: {
        keyFields: false,
      },
      TaskConnectionItem: {
        keyFields: false,
      },
      AssignedRole: {
        keyFields: false,
      },
      AssetAttributeGroup: {
        keyFields: false,
      },
      AssetAttribute: {
        keyFields: false,
      },
      TaskField: {
        keyFields: false,
      },
      TaskUser: {
        keyFields: false,
      },
      TimeEntryComputedBudget: {
        keyFields: false,
      },
      WorkOrderTemplateMedia: {
        keyFields: false,
      },
      SchemaTree: {
        keyFields: false,
      },
      // defining User.timeEntryApproverInfo array merge with cache
      // https://www.apollographql.com/docs/react/caching/cache-field-behavior#merging-arrays
      User: {
        fields: {
          timeEntryApproverInfo: {
            merge(existing = [], incoming: any[]) {
              return R.uniq([...existing, ...incoming]);
            },
          },
        },
      },
    },
  }),
  link: ApolloLink.from([errorLink, headersLink, httpLink]),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'none',
    },
    query: {
      errorPolicy: 'none',
    },
    mutate: {
      errorPolicy: 'none',
    },
  },
});

export default client;
